import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const galleryItems = [{
  id: 1,
  src: "https://mutual-wasp.10web.cloud/wp-content/uploads/2026/03/tenweb_ultra_web12-Igors.jpg?v=8b9nzm1zvf6",
  alt: "Deep sea bulk carrier vessel at blue hour",
  title: "REF_",
  category: "PERSONAL PROTECTIVE EQUIPMENT"
}, {
  id: 2,
  src: "https://mutual-wasp.10web.cloud/wp-content/uploads/2026/03/Bridge1.jpg?v=uzl4tca6yuj",
  alt: "Automated container terminal at night",
  title: "REF_",
  category: "LOGISTICS\xA0"
}, {
  id: 3,
  src: "https://mutual-wasp.10web.cloud/wp-content/uploads/2026/03/Ancla4.jpg?v=eyjg2wcceqw",
  alt: "Industrial port crane machinery",
  title: "REF_",
  category: "HEAVY EQUIPMENT"
}, {
  id: 4,
  src: "https://mutual-wasp.10web.cloud/wp-content/uploads/2026/03/Vnexus-Emotor-rewinding.jpg?v=imwsbbiuz6i",
  alt: "Maritime supply warehouse exterior",
  title: "REF",
  category: "ELECTRIC MOTOR REWINDING"
}, {
  id: 5,
  src: "https://mutual-wasp.10web.cloud/wp-content/uploads/2026/03/Vnexus-Machining.jpg?v=g316knbj3lh",
  alt: "Vessel maintenance dry dock operations",
  title: "REF_",
  category: "MACHINE SHOP WORKS"
}, {
  id: 6,
  src: "https://mutual-wasp.10web.cloud/wp-content/uploads/2026/03/Bow-welders.jpg?v=gyo4ke18j7",
  alt: "Global shipping route navigation map",
  title: "REF_",
  category: "EMERGENCY REPAIRS"
}];
export default function Gallery() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="21343" id="image-gallery" ref={ref} className={cn("bg-background py-40 transition-opacity duration-1000", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-12 text-center">
          <h2 className="text-foreground font-serif text-3xl font-bold tracking-tighter sm:text-4xl mb-4 uppercase">PROCUREMENT&nbsp; &amp; TECHNICAL Showcase</h2>
          <p className="text-muted-foreground mx-auto max-w-2xl uppercase tracking-widest !font-semibold !font-sans !text-xs">EXECUTION OF MARITIME PROCUREMENT, LOGISTICS AND TECHNICAL SUPPORT SERVICES</p>
        </div>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {galleryItems.map((item, i) => <div key={item.id} data-index={i} className="group h-full">
              <Card className="text-card-foreground flex flex-col gap-6 py-6 pt-0 h-full overflow-hidden border-border bg-card rounded-none transition-all duration-500 !shadow-[0px_36px_72px_rgba(20,21,31,0.5),_0px_18px_36px_rgba(20,21,31,0.30)] hover:border-primary">
                <CardContent className="p-0">
                  <div className="flex flex-col overflow-hidden">
                    <img src={item.src} alt={item.alt} className="aspect-[4/3] object-cover object-center transition-all duration-700 group-hover:scale-105 !text-[hsl(210,11%,15%)] !m-0 !w-[220px] !h-[350px]" />
                    
                    <p className="text-center pt-6 pb-2 font-serif text-sm font-bold tracking-widest text-foreground uppercase">
                      {item.category}
                    </p>
                  </div>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}